var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMirLogo = function SvgMirLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 181,
    viewBox: "0 0 637 181",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.556 0.255252V0.333926C171.477 0.333926 146.695 0.255252 140.087 23.9359C134.029 45.6497 116.957 105.599 116.485 107.251H111.764C111.764 107.251 94.2988 45.9644 88.1623 23.8572C81.5537 0.176579 56.693 0.255252 56.693 0.255252H0.0483398V180.417H56.693V73.4213H59.0532H61.4134L94.4561 180.417H133.793L166.835 73.5H171.556V180.417H228.201V0.255252H171.556Z",
    fill: "#4DB45E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.466 0.255249C378.466 0.255249 361.866 1.75004 354.078 19.1368L313.954 107.251H309.234V0.255249H252.589V180.417H306.087C306.087 180.417 323.474 178.843 331.262 161.535L370.599 73.4213H375.319V180.417H431.964V0.255249H378.466Z",
    fill: "#4DB45E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.139 82.0753V180.417H513.784V122.985H575.149C601.898 122.985 624.556 105.913 632.974 82.0753H457.139Z",
    fill: "#4DB45E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.149 0.255249H449.194C455.487 34.5568 481.214 62.0924 514.492 71.0611C522.045 73.1066 529.991 74.208 538.173 74.208H635.256C636.121 70.117 636.514 65.9473 636.514 61.6203C636.514 27.7122 609.057 0.255249 575.149 0.255249Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 449.209,
    y1: 37.2316,
    x2: 636.514,
    y2: 37.2316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMirLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mir-logo.ce68c201.svg";
export { ForwardRef as ReactComponent };